import React from 'react';
import { compactImage } from './ColorOption';

const DisplayIncludedProduct = ({ product, designs, collection, sizeData, handleEditProduct, index, displayNum = false }) => {
    if (!product || !designs) return null


    const qty = sizeData.reduce((acc, item) => acc + parseInt(item.qty), 0)
    const total = (sizeData.reduce((acc, item) => acc + parseInt(item.qty), 0)) * (parseFloat(product?.variants[0]?.price) + parseFloat(designs.reduce((acc, item) => acc + parseInt(item.price), 0)))
    return (
        <div className="product-option included-product" onClick={() => handleEditProduct(index)}>
            <div className="d-flex align-items-center w-100">

                <div className="info w-100 position-relative">
                    <div className="d-flex header">
                        <div className="number">
                            <div>
                                <span>
                                    {displayNum || index + 1}
                                </span>
                            </div>
                        </div>
                        <b className="Heading">{product.title}</b>
                    </div>
                    <div className="product">
                        <div className="color">
                            <b className="Heading">Color</b>
                            <img src={product.images[0].src} alt={product.images[0].altText} />
                        </div>
                        <div className="designs">
                        <b className="Heading">Designs</b>

                            {
                                designs?.length > 0 ? designs.map((design, i) => (
                                    <div key={design.id} className="design">
                                        <img src={compactImage(design.image, "50x50")} alt={design.title} />
                                        <span>{design.title}</span>
                                        <span>{design.location}</span>
                                    </div>
                                )) : "No designs"
                            }
                        </div>
                        <div className="qty-totals">
                        <b className="Heading">Totals</b>

                            <div className="sizes-qty-totals">
                                {
                                    sizeData.map((size, i) => (
                                        <div key={size.size} className="size">
                                            <span>{size.size}</span>
                                            <span>{size.qty}</span>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="qty">
                                <span>Qty:</span>
                                <span>{qty}</span>
                            </div>
                            <div className="ea">
                                <span>Ea. w/ Designs:</span>
                                <span>${parseFloat(product?.variants[0]?.price) + parseFloat(designs.reduce((acc, item) => acc + parseInt(item.price), 0))}</span>
                            </div>
                            <div className="total">
                                <span>Total:</span>
                                <span>${total}</span>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
            <div className="text-center click-edit">
                Click to edit
            </div>
        </div>
    )
}

export default DisplayIncludedProduct